import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { LegislationItem } from './legislation-items/legislation';

@Component({
    selector: 'app-legislation',
    templateUrl: './legislation.component.html',
    styleUrls: ['./legislation.component.scss'],
})
export class LegislationComponent implements OnInit {
    injectedItemData: any;
    creatingNew: boolean;

    // Indexes
    addEditItemIndex = 1;
    listItemsIndex = 0;

    @ViewChild('tabGroup') tabGroup: MatTabGroup;

    constructor() {}

    ngOnInit(): void {
        this.creatingNew = true;
    }

    editLegislationItem(data: LegislationItem) {
        this.injectedItemData = data;
        this.creatingNew = false;
        this.tabGroup.selectedIndex = this.addEditItemIndex;
    }

    resetItemData(index: number) {
        // Reset the injectedItemData vairable to null if the index returns to the list
        if (index !== this.addEditItemIndex) {
            this.injectedItemData = null;
        }
    }

    goToListView(goToListView: boolean) {
        if (goToListView) {
            this.tabGroup.selectedIndex = this.listItemsIndex;
        }
    }
}
